import County from './County';
import { AnyObject } from 'final-form';

export default class EasternMap {
    id: number;
    dlcNumber: number;
    mapTypeId: number;
    name: string;
    counties: Array<County>;
    easternTownshipId: number;

    static From(values: AnyObject) {
        const map = new EasternMap();
        map.id = values.id;
        map.name = values.name;
        map.dlcNumber = values.dlcNumber;
        map.mapTypeId = values.mapTypeId;

        map.counties = values.counties;

        return map;
    }
}



// WEBPACK FOOTER //
// ./src/models/EasternMap.ts